// extracted by mini-css-extract-plugin
export default {"App":"WelcomeCard_App__lBNLf","welcome":"WelcomeCard_welcome__lp8Fr"};